export default "__VITE_ASSET__Co$2D0Qb__"